import React from 'react';
import {Button, ButtonProps, SxProps, Theme} from '@mui/material';
import {ArrowBack} from '@mui/icons-material';
import {useNavigate} from 'react-router-dom';
import {backButtonStyles} from './styles';

interface BackButtonProps extends Omit<ButtonProps, 'onClick'> {
  onClick?: () => void;
  text?: string;
  showIcon?: boolean;
  steps?: number;
  className?: string;
  sx?: SxProps<Theme>;
}

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  text = 'Back',
  showIcon = true,
  steps = -1,
  className,
  sx,
  ...props
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(steps);
    }
  };

  return (
    <Button
      startIcon={showIcon ? <ArrowBack /> : undefined}
      onClick={handleBackClick}
      className={className}
      sx={[backButtonStyles, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...props}
    >
      {text}
    </Button>
  );
};

export default BackButton;
